<script setup lang="ts">
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

withDefaults(defineProps<Props>(), { size: 'md' });
</script>

<template>
  <span class="spinner" :class="classNames({ size })" />
</template>

<style lang="scss" scoped>
@use './Spinner.scss';
</style>
